import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import Checkbox from 'material-ui/Checkbox';

// eslint-disable-next-line react/prefer-stateless-function
export default (props) => <Checkbox {...props} />
